import { render, staticRenderFns } from "./degreeApply.vue?vue&type=template&id=0f984344&scoped=true"
import script from "./degreeApply.vue?vue&type=script&lang=js"
export * from "./degreeApply.vue?vue&type=script&lang=js"
import style0 from "./degreeApply.vue?vue&type=style&index=0&id=0f984344&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f984344",
  null
  
)

export default component.exports